import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import type { StatCardProps } from '@shared/widget-schemas';

const trendConfig = {
  up: { icon: TrendingUp, color: 'text-emerald-600', bg: 'bg-emerald-50' },
  down: { icon: TrendingDown, color: 'text-red-600', bg: 'bg-red-50' },
  stable: { icon: Minus, color: 'text-muted-foreground', bg: 'bg-muted' },
} as const;

export function StatCardWidget({ label, value, trend, unit }: StatCardProps) {
  const { icon: TrendIcon, color, bg } = trendConfig[trend];

  return (
    <Card className="w-full">
      <CardContent className="p-4">
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">{label}</p>
        <div className="flex items-baseline gap-2 mt-1">
          <span className="text-2xl font-bold">{value}</span>
          {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
        </div>
        <div className={cn('inline-flex items-center gap-1 mt-2 px-2 py-0.5 rounded-full text-xs font-medium', bg, color)}>
          <TrendIcon className="h-3 w-3" />
          <span>{trend}</span>
        </div>
      </CardContent>
    </Card>
  );
}
